import { env } from '@/config/env'

/**
 * Thin wrappers over the global `fbq()` injected by the Pixel snippet
 * in `index.html`. All calls are no-ops if `fbq` isn't loaded so we
 * don't need to guard at every call site.
 */

const fbq = (...args) => {
  if (typeof window === 'undefined') return
  if (typeof window.fbq !== 'function') return
  window.fbq(...args)
}

export const FB_PIXEL_ID = env.fbPixelId

export const pageView = () => fbq('track', 'PageView')

/** @param {import('@/types').Product} product */
export const viewContent = (product) =>
  fbq('track', 'ViewContent', {
    content_ids: [product.id],
    content_name: product.name,
    content_category: product.category,
    value: product.price,
    currency: env.currencyCode,
  })

/** @param {import('@/types').Product} product @param {number} quantity */
export const addToCart = (product, quantity) =>
  fbq('track', 'AddToCart', {
    content_ids: [product.id],
    content_name: product.name,
    value: product.price * quantity,
    currency: env.currencyCode,
  })

/** @param {import('@/types').CartItem[]} cart @param {number} total */
export const initiateCheckout = (cart, total) =>
  fbq('track', 'InitiateCheckout', {
    num_items: cart.length,
    value: total,
    currency: env.currencyCode,
  })
